import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "antd";
import { Loader } from "@vds/loaders";
import { Input } from "@vds/inputs";
import { signInConfig } from "../../global/utility/Utils";
import { useState, useEffect } from "react";
import axios from "axios";
import { resetPasswordEndPoint } from "../../configuration";
import { jwtDecode } from "jwt-decode";
import { validateEmail, validatePassword } from "../../global/utility/Utils";
import { resetOrForgotPasswordApi } from "../../pages/UserGroups/userGroupsService";

const PasswordReset = (props) => {
  let navigate = useNavigate();
  const [error, setError] = useState("");
  const [userName, setUserName] = useState("");
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [decodedToken, setDecodedToken] = useState(null);
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [isSubmitError, setIsSubmitError] = useState(false);
  const [isPasswordTouched, setIsPasswordTouched] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    length: false,
    chars: false,
    email: false,
    url: false,
    res: false,
  });

  const location = useLocation();
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [isFieldTouched, setIsFieldTouched] = useState(false);
  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };
  const token = getQueryParam("token");

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setInvalidEmail(!validateEmail(newEmail));
    setUserName(newEmail);
  };

  const handleFocus = () => {
    setIsFieldTouched(true);
    setIsSubmitError(false);
  };

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded);
        const { UserID } = decoded?.recovery;
      } catch (error) {
        console.error("Invalid token:", error);
      }
    } else {
      console.error("Invalid token:", error);
    }
  }, [location]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "confirmPassword" || name === "password") {
      setPasswordMatch(formData.password === value);
    }

    if (name === "password") {
      if (!isPasswordTouched) {
        setIsPasswordTouched(true);
      }

      // Perform password validations
      const email = userName || "";
      const currentUrl = window.location.href;
      const { isValid, errors } = validatePassword(value, email, currentUrl);

      setIsPasswordValid(isValid);
      setValidationErrors(errors);
    }
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        Username: userName,
        recoverytoken: getQueryParam("token"),
        password: formData.password,
      };
      const response = await resetOrForgotPasswordApi(
        payload,
        token,
        resetPasswordEndPoint()
      );

      if (response?.status === 200) {
        window.location.replace(
          signInConfig.oidc_provider.authorization_endpoint +
            `?` +
            `client_id=${signInConfig.client_credentials.client_id}&` +
            `redirect_uri=${signInConfig.client_credentials.redirect_uri}&` +
            `scope=${signInConfig.scopes}&` +
            `kc_idp_hide=true&` +
            `response_type=code`
        );
      } else if (response?.status === 400) {
        let responseError = "Bad Request. Please check your inputs.";
        const errorData = await response.json();
        // If status is 400 (Bad Request), get the error description
        const errorMessage = errorData?.error_description;
        if (
          errorMessage.includes(
            "Policy check failed while testing password, must not be equal to any of last 5 passwords"
          )
        ) {
          responseError =
            "New password must be different from your last 5 passwords.";
        }
        console.error("Error in reset password:", errorMessage);
        setValidationErrors({
          length: false,
          chars: false,
          email: false,
          url: false,
          res: responseError,
        });
        setIsPasswordValid(false);
        setIsSubmitError(true);
      } else {
        const genericMessage = "Something went wrong. Please try again later.";
        console.error("Unexpected response status:", response.status);
      }
    } catch (error) {
      console.error("Error in reset password:", error);
    }
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "864px",
            backgroundColor: "#000000",
            display: "flex",
          }}
        >
          <div
            style={{
              marginTop: "432px",
              display: "flex",
              marginLeft: "192px",
            }}
          >
            <h4
              style={{
                color: "#FFFFFF",
                fontWeight: "700px",
                fontSize: "44.2px",
                lineHeight: "50px",
              }}
            >
              {""}
              5G Video Insights
            </h4>
          </div>
        </div>
        <div
          style={{
            marginLeft: "200px",
            textAlign: "center",
            alignContent: "center",
          }}
        >
          <br />
          <br />
          <div style={{ display: "inline-block", textAlign: "left" }}>
            <h2
              className="text-center font-face-vzb"
              style={{
                fontWeight: "100",
                fontSize: "32px",
                marginLeft: "90px",
              }}
            >
              Reset your password
            </h2>
            <p
              style={{
                marginTop: "35px",
                marginLeft: "90px",
                fontSize: "16px",
                fontWeight: "400",
              }}
            >
              Enter a new password to reset your password.
              <br />
              Your new password must be different from your
              <br />
              old password.
            </p>
          </div>
          <br />
          <form className="sasp_login_form" style={{ textAlign: "center" }}>
            <div
              style={{
                marginTop: "30px",
                marginLeft: "90px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ marginBottom: "24px" }}>
                <Input
                  type="text"
                  label="User name"
                  width="342px"
                  value={userName}
                  required={true}
                  error={invalidEmail}
                  errorText={"Enter a valid email"}
                  onChange={handleEmailChange}
                />
              </div>

              <div style={{ marginBottom: "24px", textAlign: "left" }}>
                <Input
                  type="password"
                  name="password"
                  width="342px"
                  mask="toggle"
                  label="New password"
                  error={!isPasswordValid && isPasswordTouched}
                  success={isPasswordValid}
                  value={formData.password}
                  onChange={handleInputChange}
                  status={
                    validationErrors.length ||
                    validationErrors.chars ||
                    validationErrors.email ||
                    validationErrors.url ||
                    validationErrors.res
                      ? "error"
                      : isPasswordValid
                      ? "success"
                      : ""
                  }
                />
                {/* Password validation messages */}
                {isPasswordValid && (
                  <div
                    style={{
                      color: "black",
                      fontSize: "12px",
                      marginTop: "4px",
                      textAlign: "left",
                    }}
                  >
                    Password valid.
                  </div>
                )}
                {isPasswordTouched && (
                  <div>
                    {(validationErrors.length || validationErrors.chars) && (
                      <div
                        style={{
                          color: "black",
                          fontSize: "12px",
                          marginTop: "4px",
                          textAlign: "left",
                        }}
                      >
                        Password does not meet requirements.
                      </div>
                    )}

                    {!(validationErrors.length || validationErrors.chars) &&
                      validationErrors.email && (
                        <div
                          style={{
                            color: "black",
                            fontSize: "12px",
                            marginTop: "4px",
                            textAlign: "left",
                          }}
                        >
                          Password cannot contain login email.
                        </div>
                      )}

                    {!(validationErrors.length || validationErrors.chars) &&
                      validationErrors.url && (
                        <div
                          style={{
                            color: "black",
                            fontSize: "12px",
                            marginTop: "4px",
                            textAlign: "left",
                          }}
                        >
                          Password cannot contain web portal URL or name.
                        </div>
                      )}

                    {validationErrors.res && (
                      <div
                        style={{
                          color: "black",
                          fontSize: "12px",
                          marginTop: "4px",
                          textAlign: "left",
                        }}
                      >
                        {validationErrors.res}
                      </div>
                    )}
                  </div>
                )}
                <div style={{ marginLeft: "-9px", marginTop: "8px" }}>
                  <ul
                    style={{
                      listStyleType: "disc",
                      textAlign: "left",
                      color: !isPasswordTouched ? "#6F7171" : "inherit",
                    }}
                  >
                    <li
                      style={{
                        color: "#6F7171",
                        fontSize: "12px",
                      }}
                    >
                      Password must be a minimum of 8 characters.
                    </li>
                    <li
                      style={{
                        color: "#6F7171",
                        fontSize: "12px",
                      }}
                    >
                      Must include at least one number, one uppercase, and one
                      lowercase character.
                    </li>
                  </ul>
                </div>
              </div>

              <div style={{ textAlign: "left", marginBottom: "24px" }}>
                <Input
                  width="342px"
                  type="password"
                  name="confirmPassword"
                  label="Confirm password"
                  mask="toggle"
                  readOnly={false}
                  required={true}
                  disabled={false}
                  errorText={validationErrors.res || "Password does not match."}
                  successText={"Passwords match."}
                  error={
                    isFieldTouched &&
                    (!passwordMatch ||
                      !formData.confirmPassword ||
                      isSubmitError)
                  }
                  success={isFieldTouched && passwordMatch && isPasswordValid}
                  onFocus={handleFocus}
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  status={
                    !passwordMatch
                      ? "error"
                      : passwordMatch && isPasswordValid
                      ? "success"
                      : ""
                  }
                />
              </div>
              <br />
              <div>
                <Button
                  type="primary"
                  className="login-pageButton"
                  disabled={!isPasswordValid || !passwordMatch}
                  onClick={handleSubmit}
                >
                  Reset password
                </Button>
              </div>
            </div>
            <br />
            <br />
            <p
              style={{
                fontSize: "12px",
                fontWeight: "400",
                marginLeft: "70px",
                color: "#6F7171",
              }}
            >
              By continuing, you agree to the{" "}
              <span>
                <a
                  style={{ color: "#000000" }}
                  href="https://www.verizonenterprise.com/terms?adobe_mc=MCMID%3D79489331358806469974203692604025620162%7CMCORGID%3D7ED836675AB3A4860A495CAD%2540AdobeOrg%7CTS%3D1662453824"
                >
                  Terms & Conditions
                </a>
              </span>{" "}
              and{" "}
              <a
                style={{ color: "#000000" }}
                href="https://www.verizonenterprise.com/terms?adobe_mc=MCMID%3D79489331358806469974203692604025620162%7CMCORGID%3D7ED836675AB3A4860A495CAD%2540AdobeOrg%7CTS%3D1662453824"
              >
                Privacy policy.
              </a>
            </p>
          </form>
        </div>
      </div>
    </>
  );
};

export default PasswordReset;
